import type { GiantId } from './giantPositions';
import solImg from './sol.png';
import muImg from './mu.png';
import serjImg from './serj.png';
import monaImg from './mona.png';
import duckImg from './duck.png';
import willyImg from './willy.png';
import rozaImg from './roza.png';
import svamiImg from './svami.png';
import factorImg from './factor.png';
import yettiImg from './yetti.png';
import drakochiImg from './drakochi.png';

export const MAP_GIANT_IMAGES: Record<GiantId, string> = {
  sol: solImg,
  mu: muImg,
  serj: serjImg,
  mona: monaImg,
  duck: duckImg,
  willy: willyImg,
  roza: rozaImg,
  svami: svamiImg,
  factor: factorImg,
  yetti: yettiImg,
  drakochi: drakochiImg,
};

export function getMapGiantAssetUrls(): string[] {
  return Object.values(MAP_GIANT_IMAGES);
}
